import { ResponseStatus } from "../enums";
import {
  DatasetListItem,
  DatasetReference,
  DataSourceReference,
} from "./commonModels";

export type DataSourceFilterType = "dataset" | "kernelOutput" | "competition";

/** Type used to represent datasets shown during search of public datasets. */
export interface DataSource extends DataSourceReference {
  name?: string;
  dataSourceUrl?: string;
  dataset?: DatasetReference;
}

export interface DatasetJoinSuggestion {
  dataset: DatasetListItem;
  index: number;
  suggestionType: DatasetJoinSuggestionType;
  confidence: number;
}

export type DatasetJoinSuggestionType = string;

export interface Response {
  suggestionList: DatasetJoinSuggestion[];
  status: ResponseStatus;
}

export interface Request {
  kernelId: number;
  count: number;
}

// TODO(cchamberlin): implement getJoinSuggestions
export const getJoinSuggestions = async (
  _request: Request
): Promise<Response> => {
  return undefined as any;
};
